var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("셀프 체크리스트")]),_c('div',[_vm._v(" 수강신청 페이지 제작 후, 꼭 체크해야 할 주요 항목 리스트입니다. "),_c('br'),_vm._v(" 수강신청 전, 미리보기를 통해서 실제 사용자 화면단으로 테스트 진행을 꼭 해주십시오. ")])])
}]

export { render, staticRenderFns }